import { ApiConfig } from '../../../Config.js';
import axios from 'axios';


var RegisterPVCtrl = function (fn, er, state, ids) {

	var config = {
		headers: {
			//'Authorization': 'Bearer ' + token,
			'Content-Type': 'application/json',
			'MT_SESSION_ID': ids
		},

	};
	var data = {
		cell: state.numtel,
  		codVat: state.piva,
  		codZip: state.capsocieta,
  		companyCode: state.codsocieta,
  		posCod: state.codicepv,
		captcha: state.captcha
	};

	axios
		.post(ApiConfig.url.REGISTER_POS, data, config)
		.then(function (result) {
			fn(result.data, result.status)
		})
		.catch(function (error) {
			er(error !== undefined && error.response !== undefined && error.response.status !== undefined ? error.response.status : 500)
		});
}

export { RegisterPVCtrl };